module.exports = __webpack_public_path__ + "static/bch-icon-qrcode-og-d018908125ad4282428fb451ee7cd224.png";